module.exports = __webpack_public_path__ + "static/img/img-aboutus-01.cbb0445.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/mobile/img-aboutus-01.png
// module id = tCLj
// module chunks = 1